<div class="wrapper">
  <!--header-->
  <div class="header-wrapper" >
    <header class="header">
      <app-header [isShown]="isSubShown"></app-header>
    </header>
  </div>
  <!--header ends-->
  <!--body part-->
  <div class="sidemenu-body">
    <!--Side Menu-->
    <div class="side-menu-wrapper">
      <nav class="menu-sidebar d-flex shadow-right">
        <div [hidden]="!isMenuShown" class="menu-sidebar-wrap shadow-right ">
          <ul class="side-menu-list ">
            <li [routerLinkActive]="['active']" class="tooltips-container cursor" (click)="selectedTab(menuItem?.name)"
              *ngFor="let menuItem of leftMainMenu; let i = index"
              [ngClass]="service.rbacManagement(menuItem?.privilege)?'':'disableMenu'">
              <span><a [class.disabled]="disableMenu ? true : null">
                  <img [src]="menuItem?.imgUrl" class="h-30" alt="home"><span>{{ menuItem?.code |
                    translate
                    }}</span></a>
              </span>
              <span class="tooltiptext" [class.disabled]="disableMenu ? true : null"
                [routerLink]="[menuItem?.code]"></span>
            </li>
          </ul>
        </div>
        <ng-container>
          <div class="dropdownList scroll-container scroll-restrict" [ngClass]="{'sidemenu-display' : hideSubMenu}"
            aria-labelledby="navbarDropdownMenuLink1 shadow-right" [@slideInOut]="isSubShown">
            <h1></h1>
            <a *ngFor="let item of menuList; let i = index" class="dropdown-item cursor"
              [ngClass]="{'active-submenu': item.isActive,
                            'disableMenu':!service.rbacManagement(item.privilege)}" (click)="redirectTo(i)">
              <ng-container
                *ngIf="(((item.nav==='assets/active' || item.nav==='vehicles/active')&&service.getConfiguration('tenantGenericConfig')?.twinLabel) || ((item.nav==='analytics/analysis1' || item.nav==='analytics/analysis2' || item.nav==='analytics/analysis3' || item.nav==='analytics/analysis4') && getAnalyticsLabel(item.nav)) ); else defaultLabel">
                {{ ((item.nav==='assets/active' || item.nav==='vehicles/active') ? service.getConfiguration('tenantGenericConfig')?.twinLabel : getAnalyticsLabel(item.nav)) }}
              </ng-container>
              <ng-template #defaultLabel>
                {{item?.name | translate}}
              </ng-template>
            </a>
          </div>
        </ng-container>
      </nav>
    </div>
    <!--Sidemenu ends-->
    <!--Body-->
    <div class="main" #mainlayout (click)="toggleShow()">
      <main class="content">
        <div class="content-area">
          <!-- Header and breadcrumb -->
          <div class="crumb-wrapper d-flex">
            <div class="d-flex align-items-baseline">
              <h1 class="title uni-title" *ngIf="!selectedSiteProfile?.length">{{selectedMenuItem?.title}}</h1>
              <h1 class="title uni-title" *ngIf="selectedSiteProfile?.length">{{selectedSiteProfile}}</h1>
              <span [hidden]="!selectedMenuItem?.crumb.length || selectedMenuItem?.crumb.length<2" class="bread-crumb"
                *ngFor="let crumbItem of selectedMenuItem?.crumb; let i = index">
                <span (click)="selectedTab(tab?.name,'crumb')" [ngClass]="{'cursor': i<(selectedMenuItem?.crumb.length-1),'pointer': i>=(selectedMenuItem?.crumb.length-1)}">{{crumbItem | titlecase | translate}}</span>&nbsp;
                <span *ngIf="i<selectedMenuItem?.crumb.length-1">|</span>&nbsp;&nbsp;
              </span>
            </div>
            <!-- dashboard edit -->
            <div class="widget-edit ml-auto" *ngIf="tab?.code==='home'">
                  <div *ngIf="!service.rbacManagement('home_RangeFilter')"
                    class="d-flex justify-content-center align-items-center time-display">
                    <span class="time-display-label">As of &nbsp;</span> {{ (now | date:'dd MMM y, hh:mm:ss aaa':'en-US')}}
                  </div>
              <div *ngIf="service.rbacManagement('home_RangeFilter')" class="d-flex gap-2">
                <div class="widget-edit pdt-5 calender-pop-scroll report-date-field home-datetime-range">
                  <form [formGroup]="datepickerForm">
                  <app-datetime-range class="" formControlName="thisdate" [isDisabled]="false" [label]="'Date Range'" [autoApply]="false"
                    [showCancel]="true" [timePicker]="true" [timePicker24Hour]="true" [timePickerSeconds]="true"
                    [showCustomRangeLabel]="true" [alwaysShowCalendars]="true" [keepCalendarOpeningWithRange]="true" (rangeSelected)="saveTime($event)"
                    [opens]="'left'">
                  </app-datetime-range>
                  </form>
                </div>
                <!-- <mat-form-field appearance="outline">
                  <mat-select [formControl]="dateRange" panelClass="multiSelectPanel" placeholder="Date Range">
                    <mat-option *ngFor="let item of dateRangeList" [value]="item?.value">
                      {{item?.name}}
                    </mat-option>
                  </mat-select>
                </mat-form-field> -->
              </div>
              <div class="d-flex align-items-center"><img src="../../../../assets/images/editIcon.svg" title="edit" alt="edit" (click)="onWidgetEdit()"
                class="h-30 cursor" *ngIf="service.rbacManagement('home_EditWidget') && !isEditable"></div>
              <span *ngIf="service.rbacManagement('home_EditWidget') && isEditable" class="d-flex position-relative gap20">
                <a (click)="onWidgetSave('submit')" title="Submit"><img
                    src="../../../../assets/images/dover-add-icon.svg" title="Submit" alt="Submit"
                    class="h-25 cursor"></a>
                <a (click)="onWidgetSave('cancel')" title="Cancel"><img
                    src="../../../../assets/images/dover-close-icon.svg" title="Cancel" alt="Cancel"
                    class="h-25 cursor"></a>
              </span>
            </div>
            <div class="profile-view-toggle" *ngIf="isdigitalTwin">
              <span class="profile-view-car cursor" (click)="navigateTo()">
                <span>
                  <img src="../../assets/images/profile-car.svg" alt="profile-view-car">&nbsp;&nbsp;
                </span><span>Profile View</span>
              </span>
            </div>
            <!-- dateTime picker
                        <div class="widget-edit ml-auto pdt-5" *ngIf="tab?.code === 'developer'">
                            <form [formGroup]="datepickerForm">
                                <app-datetime-range formControlName="thisdate" [label]="'Date Range'"
                                    [autoApply]="false" [showCancel]="true" [timePicker]="true"
                                    [timePicker24Hour]="true" [timePickerSeconds]="true" [showCustomRangeLabel]="true"
                                    [alwaysShowCalendars]="true" [keepCalendarOpeningWithRange]="true" [opens]="'left'"
                                    (datePassed)="saveTime($event)" (rangeSelected)="rangeSelected($event)">
                                </app-datetime-range>
                            </form>
                        </div> -->
          </div>
          <!-- Header and breadcrumb ends-->
          <router-outlet>
            <div *ngIf="service.rbacManagement('ichat')">
              <button type="button" class="btn btn-cta position-fixed demo" *ngIf="!isChatBot" (click)="chatOpen()"
                (cdkDragStarted)="handleDragStart($event)" cdkDrag><img src="../../assets/images/rocketicon.svg"
                  class="img-fluid" alt=""></button>
              <div *ngIf="isChatBot">
                <app-chat-bot (botAction)="botAction($event)">
                </app-chat-bot>
              </div>
            </div>
          </router-outlet>
          <app-socket-notification></app-socket-notification>
        </div>
      </main>
      <!--footer-->
      <app-footer *ngIf="!router.url.includes('/home')"
        [ngClass]="{'app-foot tagLine': service.getConfiguration('tenantGenericConfig')?.tenantTagLine}">
      </app-footer>
      <!--footer ends-->
    </div>
    <!--Body ends-->
  </div>
  <!--bodypart ends-->
</div>
<div class="mask" *ngIf="openNotificationBar">
  <div class="masking" (click)="appClickOutside()"></div>
  <ul class="notification-popup">
    <li class="d-grid">
      <div class="notification-header mb-2 align-items-center d-flex jc-space">
        <div class="d-flex align-items-center">
          <div class="mr-2">Notifications</div><span class="round-box-notify">{{notificationList?.length?
            notificationList?.length : 0}}</span>
        </div>
        <div class="clearall" *ngIf="notificationList?.length" (click)="clearNotification()">Clear All</div>
        <button class="close-notification" (click)="appClickOutside()">X</button>
      </div>
      <div class="notification-box mb-2" *ngFor="let notification of notificationList">
        <!-- <div class="notification-header">Notification</div> -->
        <div class=" message-indicator d-flex" [style.border-left-color]="setToastrStyle(notification?.type,'color')">
          <!-- img url -->
          <!-- <div class="notification-icon"><img [src]="setToastrStyle(notification?.type,'notificationUrl')"
            alt="info"></div> -->
          <div class="notification-message  w-100 bw">
            <div class="d-flex jc-space align-items-center">
              <div [ngClass]="notification?.status=='edited'? 'edit-status' : 'status'" >{{notification?.status | titlecase}}</div>
              <div>{{notification?.convertedTime}}</div>
            </div>
            <div class="d-flex">
              <div class="notification-number">{{notification?.type}}</div>
              <!-- <div class="notification-name">Albert Einstien</div> -->
            </div>
            <div class="notification-message">{{notification?.message}}</div>
            <!-- <div class="notification-time">23 jan 12.30pm</div> -->
          </div>
        </div>
      </div>
      <!-- <div class="notification-box mb-2">
        <div class="notification-header">Notification</div>
        <div class=" message-indicator">
          <div class="notification-icon"></div>
          <div class="notification-message">
            <div class="d-flex">
              <div class="notification-number">asp1234-</div>
              <div class="notification-name">Albert Einstien</div>
            </div>
            <div class="notification-message">Completed daily test for the patient</div>
            <div class="notification-time">23 jan 12.30pm</div>
          </div>
        </div>
      </div> -->
    </li>
  </ul>
</div>